import { render, staticRenderFns } from "./PromoteEvent.vue?vue&type=template&id=289a9014&scoped=true&"
import script from "./PromoteEvent.vue?vue&type=script&lang=js&"
export * from "./PromoteEvent.vue?vue&type=script&lang=js&"
import style0 from "./PromoteEvent.vue?vue&type=style&index=0&id=289a9014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a9014",
  null
  
)

export default component.exports